import type { CareerTrackDistribution } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.careerPath.detailPage.trackDistribution;

export const useAgentContext = (careerTrackDistribution: CareerTrackDistribution) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Career Tracks',
    description: 'Distribution of roles in this career path across the five career track tiers.',
    detail: STRINGS.description,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Track Distribution',
    display:
      'Donut chart showing percentage of roles in each career track tier, with a color-coded legend and percentage labels',
    data: { career_track_distribution: careerTrackDistribution },
  });
};
